<script lang="ts">
  interface Props {
    isHovered: boolean
    onIgnore: (e: MouseEvent) => void
  }
  
  let { isHovered, onIgnore }: Props = $props()
</script>

{#if isHovered}
  <button
    class="ignore-button"
    onclick={onIgnore}
    title="무시"
  >
    ✕
  </button>
{/if}

<style>
  /* Ignore button - top right on hover */
  .ignore-button {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 18px;
    height: 18px;
    padding: 0;
    background: transparent;
    border: none;
    color: var(--text-tertiary);
    font-size: 12px;
    cursor: pointer;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    opacity: 0;
    animation: fadeIn 0.15s ease forwards;
    z-index: 10;
  }
  
  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
  
  .ignore-button:hover {
    background: rgba(239, 68, 68, 0.1);
    color: var(--error);
  }
  
  /* Mobile optimizations */
  @media (max-width: 768px) {
    /* Always show ignore button on mobile */
    .ignore-button {
      opacity: 0.5;
    }
  }
  
  /* Dark mode support - colors already handled by CSS variables */
  
  /* Reduced motion */
  @media (prefers-reduced-motion: reduce) {
    .ignore-button {
      transition: none;
      animation: none;
      opacity: 1;
    }
  }
</style>